module.exports = __webpack_public_path__ + "static/media/add-icon.af7a2b4d.svg";